import * as React from "react";
import { Link } from "react-router-dom";
import MyChartContainer from "../mychart/MyChartContainer";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import { MyChartHeading } from "../ecosystem/mybswh";

const Coverage = () => {
    logUI("MBHWeb.UI.Coverage.ComponentDidMount", new Date(), Tools.getURLPath());
    const bswMatch = ".card";
    const events = [{ elements: ".formbuttons .button", eventName: "click", message: "touched" }];

    const { proxyName } = Tools.getProxyName();
    const heading = <MyChartHeading
        heading="Coverage"
        headingButton={{
            label: "Insurance",
            to: { pathname: '/insurance' }
        }}
        proxyName={proxyName}
    />;

    return <MyChartContainer
        mode="coverage"
        title="Coverage"
        heading={heading}
        events={events}
        bswMatch={bswMatch}
/>;
};

export default Coverage;